import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { getAddressNotConfirmedList, sendAddressNotConfirmedToTelegram } from './api'
import { IAddressNotConfirmedActions, IAddressNotConfirmedItem, IAddressNotConfirmedState } from './state.types'
import { createLatestRequestController } from '../latest-request'


export const initialStateAddressNotConfirmed: IAddressNotConfirmedState = {
    error: null,
    addresses: {
        isLoading: false,
        isSending: false,
        sendingPrintID: 0,
        items: [] as IAddressNotConfirmedItem[],
        totalCount: 0,
        pageSize: 0,
        currentPage: 0,
        weekRange: {
            monday: '',
            friday: '',
        },
    },
}

const addressListRequest = createLatestRequestController()

/** Хранилище страницы - Адреса не подтверждены. */
export const useAddressNotConfirmed = create<IAddressNotConfirmedState & IAddressNotConfirmedActions>()(devtools((set) => ({
    ...initialStateAddressNotConfirmed,

    /** Сброс хранилища до начального состояния. */
    clearAddressNotConfirmedState: () => {
        addressListRequest.invalidate()
        set(initialStateAddressNotConfirmed)
    },

    /** Запрос на получение основного списка неподтверждённых адресов. */
    actionGetAddressNotConfirmedList: async (pageNumber: number, search: string) => {
        const request = addressListRequest.start()
        set((state) => ({ addresses: { ...state.addresses, isLoading: true } }))

        const res = await getAddressNotConfirmedList(pageNumber, search, request.signal)
        if (!request.isCurrent()) return
        request.finish()

        if (res.status !== 200) set({ error: { type: res.status === 500 ? 'error' : 'warning', message: res.message } })

        if (res.message === 'OK') {
            set({ error: null })
            set((state) => ({
                addresses: {
                    ...state.addresses,
                    items: res.data!.items,
                    totalCount: res.data!.totalCount,
                    pageSize: res.data!.pageSize,
                    currentPage: res.data!.currentPage,
                    weekRange: res.data!.weekRange,
                },
            }))
        }

        set((state) => ({ addresses: { ...state.addresses, isLoading: false } }))
    },

    /** Запрос на отправку выбранной записи в Telegram канал адресов. */
    actionSendAddressNotConfirmedToTelegram: async (printID: number) => {
        set((state) => ({ addresses: { ...state.addresses, isSending: true, sendingPrintID: printID } }))

        const res = await sendAddressNotConfirmedToTelegram(printID)
        if (res.status !== 200) set({ error: { type: res.status === 500 ? 'error' : 'warning', message: res.message } })
        else set({ error: null })

        set((state) => ({ addresses: { ...state.addresses, isSending: false, sendingPrintID: 0 } }))

        return res.status
    },
})))